<template>
    <div class="custom-style-navbar">
        <div class="sidebar-header">
            <img :src="logo" class="brand-logo" />
            <!-- <unicon v-if="!mobile" class="p-2 icon-normal" name="times-circle" @click="close" /> -->
        </div>

        <div class="sidebar-user">
            <div class="sidebar-user-info">
                <span class="sidebar-user-name">{{ userName }}</span>
                <span class="sidebar-user-role">{{ userRole }}</span>
            </div>

            <div class="theme-switch">
                <i :class="isDarkMode ? 'pi pi-moon' : 'pi pi-sun'"></i>
                <ToggleSwitch
                    input-id="sidebar-theme-toggle"
                    :model-value="isDarkMode"
                    @update:model-value="toggleThemeMode"
                />
            </div>
        </div>

        <div class="sidebar-divider">
            <Divider />
        </div>

        <ul class="nav-list">
            <li class="flex my-2 cursor-pointer" v-for="(options, index) in filterNavs" :key="index">
                <div
                    :class="[currentRoute == options.name ? 'active' : '']"
                    class="nav-option flex-1 cursor-pointer"
                    @click="pushRoute(options.route)"
                    v-ripple
                >
                    <span>{{ options.name }}</span>
                </div>
            </li>
            <li class="flex my-2 cursor-pointer">
                <a
                    href="https://status.services.eludico.io/status/conecta"
                    target="_blank"
                    class="nav-option status-link flex-1 cursor-pointer"
                >
                <span>C.onecta status</span>
                </a>
            </li>
        </ul>

        <footer class="sidebar-footer">
            <div class="sidebar-divider">
                <Divider />
            </div>

            <div role="button" class="logout-button" @click="logoff" v-ripple>
                <i class="pi pi-sign-out"></i>
                <span>Sair</span>
            </div>

            <span class="sidebar-version">v{{ version }}</span>
        </footer>
    </div>
</template>

<script>
    import { computed, onMounted, ref, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import authentication from '@/plugins/authentication';
    import { useColorMode } from '@/composables/useColorMode';
    export default {
        setup() {
            const router = useRouter();
            const route = useRoute();

            const isOpen = ref(false);
            const optionsNav = ref([]);
            const logo = require('@/assets/img/logo.png');
            const version = window.version || '';
            const { isDark } = useColorMode();
            const isDarkMode = ref(false);

            function pushRoute(path) {
                router.push(path);
            }
            function close() {
                isOpen.value = !isOpen.value;
            }
            function logoff() {
                authentication.logout();
                router.push('/login');
            }

            function toggleThemeMode(value) {
                const nextIsDark = typeof value === 'boolean' ? value : !isDark.value;
                document.documentElement.classList.add('theme-switching');
                isDark.value = nextIsDark;
                isDarkMode.value = nextIsDark;
                window.setTimeout(() => {
                    document.documentElement.classList.remove('theme-switching');
                }, 240);
            }

            const currentRoute = computed(() => {
                console.log(route.meta.module);
                return route.meta.module;
            });

            const filterNavs = computed(() => {
                return optionsNav.value.filter((item) => {
                    return item.showNav;
                });
            });

            const userName = computed(() => {
                return authentication.user?.name || authentication.user?.email || 'Dashboard';
            });

            const userRole = computed(() => {
                return authentication.accessLevel || 'Administrador';
            });

            onMounted(() => {
                isDarkMode.value = isDark.value;
                optionsNav.value = router.options.routes[2].children.map((item) => {
                    return {
                        name: item.meta.module,
                        route: item.path,
                        mode: item.meta.mode,
                        showNav: item.meta.showNav,
                    };
                });
            });

            watch(isDark, (value) => {
                isDarkMode.value = value;
            });

            return {
                pushRoute,
                close,
                logoff,
                currentRoute,
                isOpen,
                optionsNav,
                logo,
                filterNavs,
                userName,
                userRole,
                version,
                isDarkMode,
                toggleThemeMode,
            };
        },
    };
</script>

<style lang="scss">
    .custom-style-navbar {
        width: clamp(260px, 20vw, 300px);
        background: #f5f5f5;
        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);
        border-right: 1px solid #d4d4d4;
        border-radius: 0 1rem 1rem 0;
        position: fixed;
        height: 100vh;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        transition: all 0.2s ease-in;
        z-index: 98900;

        .sidebar-header {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding: 1.5rem 1.25rem 1rem;
            transition: all 0.2s ease-in;
        }

        .brand-logo {
            max-height: 4rem;
            max-width: 100%;
            height: auto;
            object-fit: contain;
        }

        .sidebar-user {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 0.75rem;
            width: 100%;
            min-width: 0;
            padding: 0.75rem 1.5rem 0.5rem;
        }

        .sidebar-user-info {
            display: flex;
            min-width: 0;
            flex: 1;
            flex-direction: column;
        }

        .sidebar-user-name {
            overflow: hidden;
            color: #434343;
            font-size: 0.875rem;
            font-weight: 600;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .sidebar-user-role {
            color: #707070;
            font-size: 0.75rem;
        }

        .sidebar-divider {
            width: 100%;
            padding: 0 1rem;
        }

        .theme-switch {
            display: flex;
            align-items: center;
            flex: 0 0 auto;
            gap: 0.5rem;
            color: #707070;
            padding-top: 0.125rem;

            i {
                font-size: 1rem;
            }
        }

        .nav-list {
            list-style: none;
            padding: 0 0 0 1.25rem;
            margin: 0;
            width: 100%;
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
        }

        .nav-option {
            display: block;
            width: 100%;
            padding: 0.75rem 0.75rem 0.75rem 1rem;
            color: #515c6f;
            background: transparent;
            border: 2px solid transparent;
            border-radius: 999px 0 0 999px;
            font-weight: 500;
            text-align: left;
            text-decoration: none;
            transition: transform 0.18s ease, background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;

            span {
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 1rem;
                letter-spacing: 0;
            }

            &:hover {
                color: #122868;
                background: rgba(255, 174, 0, 0.16);
                border-color: rgba(18, 40, 104, 0.18);
            }

            &.active {
                color: #ffffff;
                background: #ffae00;
                border-color: #ffae00;
                box-shadow: none;
            }

            &.status-link {
                color: #515c6f;
            }
        }

        .sidebar-footer {
            margin-top: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            transition: all 0.2s ease;
        }

        .logout-button {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            width: 100%;
            padding: 0.5rem;
            border: 0;
            color: #ea5455;
            background: transparent;
            font-size: 1.125rem;
            font-weight: 600;
            letter-spacing: 0;
            cursor: pointer;
            transition: background-color 0.18s ease;

            &:hover {
                background: rgba(18, 40, 104, 0.04);
            }
        }

        .sidebar-version {
            display: block;
            width: 100%;
            padding: 0 0.5rem 0.5rem;
            color: rgba(34, 41, 47, 0.4);
            font-size: 0.875rem;
        }

        &.mobile-active {
            img {
                width: 86%;
                height: auto;
            }

            &.active {
                transform: translateX(-200px);
            }
        }
    }

    @media (min-width: 1536px) {
        .custom-style-navbar {
            width: clamp(260px, 15vw, 300px);
        }
    }

    .dark {
        .custom-style-navbar {
            background: #262626;
            border-right-color: #404040;
            box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
        }

        .sidebar-user-name {
            color: #f5f5f5;
        }

        .sidebar-user-role,
        .theme-switch,
        .nav-option,
        .nav-option.status-link {
            color: #d4d4d4;
        }

        .nav-option:hover {
            color: #f5f5f5;
            background: rgba(255, 174, 0, 0.18);
            border-color: rgba(255, 174, 0, 0.4);
        }

        .sidebar-version {
            color: rgba(245, 245, 245, 0.4);
        }
    }
</style>
